/**
 * CSVItemError is to be used to identify an error in a cell
 * of a CSV document when converting CSV to JSON.
 */
export class CSVItemError extends Error {
    /**
     *
     * @param message Error message
     * @param column index of column error
     * @param row index of row error
     * @param value apparent value of cell
     */
    constructor(
        message: string,
        public readonly column: number,
        public readonly row: number,
        public readonly value: string
    ) {
        super(message)
        this.name = "CSVItemError"
    }
}
